require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).SortDescending = e.SortDescending || {}, e.SortDescending.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function n(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var a = n(e),
      i = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function c() {
    return c = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, c.apply(this, arguments);
  }

  function u(e, r) {
    if (null == e) return {};

    var t,
        l,
        n = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          n = {},
          a = Object.keys(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || (n[t] = e[t]);
      }

      return n;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);

      for (l = 0; l < a.length; l++) {
        t = a[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
      }
    }

    return n;
  }

  function f(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      d,
      b = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var p = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        n = e.size,
        i = void 0 === n ? 16 : n,
        y = e.title,
        g = e["aria-label"],
        m = e["aria-labelledby"],
        O = e.fill,
        C = e.role,
        h = void 0 === C ? "img" : C,
        v = u(e, p),
        j = t.css(s || (s = f(["\n    color: ", ";\n  "])), O),
        w = t.css(d || (d = f(["\n    flex-shrink: 0;\n  "]))),
        x = function (e, r, t) {
      var l,
          n,
          a = t["aria-label"],
          i = t["aria-labelledby"],
          c = t.title;

      switch (e) {
        case "img":
          return a || i || c ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", a), o(l, "title", c), l) : {
            "aria-label": (n = r, "".concat(n.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(h, "SortDescending", (o(r = {
      title: y
    }, "aria-label", g), o(r, "aria-labelledby", m), r));

    return a.createElement("svg", c({
      className: t.cx(o({}, j, null != O), w, l),
      height: "number" == typeof i ? i : b[i],
      width: "number" == typeof i ? i : b[i],
      role: h
    }, x, v, {
      viewBox: "0 0 16 16"
    }), a.createElement("path", {
      d: "M4.44991 14.6959C4.23029 14.8861 3.90429 14.8861 3.68466 14.6959L1.20302 12.5467C0.793944 12.1925 1.04449 11.5205 1.58564 11.5205H2.89835V2.16894C2.89835 1.52335 3.4217 1 4.06729 1C4.71287 1 5.23623 1.52335 5.23623 2.16894V11.5205H6.54893C7.09009 11.5205 7.34063 12.1925 6.93156 12.5467L4.44991 14.6959Z",
      fill: "currentColor"
    }), a.createElement("path", {
      d: "M8 3C7.44772 3 7 3.44772 7 4C7 4.55229 7.44772 5 8 5H14C14.5523 5 15 4.55229 15 4C15 3.44772 14.5523 3 14 3H8Z",
      fill: "currentColor"
    }), a.createElement("path", {
      d: "M7 7C7 6.44772 7.44772 6 8 6H12C12.5523 6 13 6.44772 13 7C13 7.55229 12.5523 8 12 8H8C7.44772 8 7 7.55229 7 7Z",
      fill: "currentColor"
    }), a.createElement("path", {
      d: "M8 9C7.44772 9 7 9.44771 7 10C7 10.5523 7.44772 11 8 11H10C10.5523 11 11 10.5523 11 10C11 9.44771 10.5523 9 10 9H8Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "SortDescending", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});